import { InvoiceSplitRuleType } from "@sp-crm/core";

export interface SplitRuleDraft {
    type: InvoiceSplitRuleType;
    recipientTerritoryId: string;
    ratePercent: string;
    enabled: boolean;
    notes: string;
}

export interface SplitAllocation {
    label: string;
    percent: number;
    cents: number;
}

export interface SplitDistribution {
    allocations: SplitAllocation[];
    officePercent: number;
    officeCents: number;
    totalSplitPercent: number;
    overAllocated: boolean;
}

export const computeSplitDistribution = (
    rules: SplitRuleDraft[],
    totalCents: number,
    labelByTerritoryId: Map<string, string>,
): SplitDistribution => {
    const allocations = rules
        .filter(rule => rule.enabled && rule.recipientTerritoryId !== "")
        .map(rule => {
            const percent = parseFloat(rule.ratePercent || "0") || 0;
            return {
                label:
                    labelByTerritoryId.get(rule.recipientTerritoryId) ??
                    "Unknown recipient",
                percent,
                cents: Math.round((totalCents * percent) / 100),
            };
        });

    const totalSplitPercent = allocations.reduce((sum, a) => sum + a.percent, 0);
    const allocatedCents = allocations.reduce((sum, a) => sum + a.cents, 0);

    return {
        allocations,
        officePercent: 100 - totalSplitPercent,
        officeCents: totalCents - allocatedCents,
        totalSplitPercent,
        overAllocated: totalSplitPercent > 100,
    };
};
